import { InputText } from 'components';
import { Loading } from 'components';
import { Button, InputWraper } from 'modules';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MainRouteKeys } from 'routes/enums';
import { useGetBalanceQuery } from 'services';

const BalanceManagementFeatures = (): JSX.Element => {
  const navigate = useNavigate();

  const { data, isLoading } = useGetBalanceQuery();

  const nomorlizeBalance = (balance: number) => {
    return Number(balance).toLocaleString('vi-VN') + ' đ';
  };

  return (
    <div className='container-fluid balance-management'>
      <Loading isLoading={isLoading}>
        <div className='row balance-management__wrap'>
          <div className='col-8 col-lg-4'>
            <InputWraper
              label='Số dư'
              component={InputText}
              inputProps={{
                value: data ? nomorlizeBalance(data.balance) : '',
                name: 'balance',
                isDisabled: true,
                onChange: () => {},
                onTouched: () => {},
              }}
            />
          </div>

          <div className='col-12 balance-management__action'>
            <Button
              className='balance-management__action__top-up'
              label={'Nạp điểm'}
              type='button'
              buttonType='success'
              onClick={() => navigate(MainRouteKeys.TopUp)}
            />

            <Button
              className='balance-management__action__transfer ml-3'
              label={'Chuyển điểm'}
              type='button'
              buttonType='success'
              onClick={() => navigate(MainRouteKeys.Transfers)}
            />
          </div>
        </div>
      </Loading>
    </div>
  );
};

export default BalanceManagementFeatures;
